import { z } from 'zod';

export const teamManagementFormSchema = z.object({
  id: z.string().optional(),
  name: z.string().trim().min(1),
  memberUserIds: z.array(z.string()),
  memberTeamIds: z.array(z.string()),
  scopeIds: z.array(z.string()),
});

export type TeamManagementFormData = z.infer<typeof teamManagementFormSchema>;

export const teamManagementFormDefaults: TeamManagementFormData = {
  name: '',
  memberUserIds: [],
  memberTeamIds: [],
  scopeIds: [],
};
